import { COMMENT_DETAILS } from './shared';

export const PRIVATE_BASE_COMMENT_FRAGMENT = `
  fragment PrivateBaseCommentFragment on PrivateComment {
    ${COMMENT_DETAILS}
  }
`;
